
import { Placement } from '@post-office/placements-frontend/issue-navigator-placement';
export default Placement;
